import React from 'react'
import SocialLoginButtons from '../registration/social-login-buttons/SocialLoginButtons'
import AuthShell from 'src/components/elements/auth-shell/AuthShell'
import { Link } from 'react-router-dom'
import RegistrationForm from './form/RegistrationForm'
import { useTranslation } from 'react-i18next'

// Finishing an account: the shared sign-in shell, the completion form and
// the same ways in as the sign-up page
const CompleteRegistration: React.FC = () => {
  const { t } = useTranslation()

  return (
    <AuthShell title={t('registration.title')} subtitle={t('registration.subtitle')}>
      <p className="m-0 flex gap-2.5 items-start px-3.5 py-3 rounded-xl bg-muted-soft text-sm leading-5 text-muted">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          aria-hidden="true"
          className="shrink-0 mt-px"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v5M12 7.5v.5" />
        </svg>
        {t('completeRegistration.profileNote')}
      </p>
      <RegistrationForm />
      <SocialLoginButtons />
      <div className="flex flex-wrap gap-x-2 items-center justify-center text-[0.9375rem]">
        <p className="m-0 text-ink-2">{t('socialLogin')}</p>
        <Link
          to="/login"
          className="min-h-11 inline-flex items-center font-bold text-brand-ink hover:underline"
        >
          {t('loginLink')}
        </Link>
      </div>
    </AuthShell>
  )
}

export default CompleteRegistration
